<template>
  <li class="icon-row__item">
    <button
      :style="buttonBg"
      class="icon-row__button"
      @click="$emit('buttonClick', id)"
    ></button>
  </li>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    iconLabel: {
      type: String,
      required: true
    }
  },
  computed: {
    buttonBg () {
      const img = require(`@/assets/illustrations/${this.image}`)

      return `background-image: url('${img}')`
    }

  }
}
</script>

<style>
.icon-row__item {
  list-style: none;
  /* width:  */
}

.icon-row__button {
  background-color: unset;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  height: 2rem;
  padding: 0;
  width: 2rem;
}
</style>
